export const EXAMPLE_API_KEY = 'LIVDSRZULELA';

export const API_DOCS_TOC = [
    {label: 'Quickstart',
        id: 'quickstart',
        icon: '/assets/img/api/quickstart.svg',
        listItems: [
            {label: 'Setup', id: 'setup'},
            {label: 'Search', id: 'search'},
            {label: 'Share', id: 'share'},
            {label: 'Enhanced Search', id: 'enhancedsearch'},
        ],
    },
    {label: 'Endpoints',
        id: 'endpoints',
        icon: '/assets/img/api/endpoints.svg',
        listItems: [
            {label: 'Search', id: 'search'},
            {label: 'Trending GIFs', id: 'trendinggifs'},
            {label: 'Categories', id: 'categories'},
            {label: 'Search Suggestions', id: 'suggestions'},
            {label: 'Autocomplete', id: 'autocomplete'},
            {label: 'Trending Search Terms', id: 'trendingterms'},
            {label: 'Register Share', id: 'registershare'},
            {label: 'GIFs', id: 'gifs'},
            {label: 'Random GIFs', id: 'random'},
            {label: 'Anonymous ID', id: 'anonymousid'},
            {label: 'Domains', id: 'domains'},
        ],
    },
    {label: 'Custom APIs', id: 'custom', icon: '/assets/img/api/gear.svg'},
    {label: 'Response Objects & Errors',
        id: 'responseobjects',
        icon: '/assets/img/api/layers.svg',
        listItems: [
            {label: 'GIF Object', id: 'gif'},
            {label: 'Category Object', id: 'category'},
            {label: 'Media Object', id: 'media'},
            {label: 'GIF Formats', id: 'gifformat'},
            {label: 'Response Codes', id: 'codes'},
            {label: 'Errors', id: 'errors'},
        ],
    },
    {label: 'Localization', id: 'localization', icon: '/assets/img/api/globe.svg'},
    {label: 'Content Filtering', id: 'contentfilter', icon: '/assets/img/api/search.svg'},
    {label: 'SDKs', id: 'sdk', icon: '/assets/img/api/SDK.svg'},
    {label: 'API Terms', id: 'apiterms', icon: '/assets/img/api/file-minus.svg'},
    {label: 'Attribution', id: 'attribution', icon: '/assets/img/api/attribution.svg'},
    {label: 'Support', id: 'support', icon: '/assets/img/api/support.svg'},
];


function getHrefs() {
    const ids = [];
    for (const section of API_DOCS_TOC) {
        if (section.id) {
            ids.push(section.id);
        }
        if (section.listItems) {
            for (const subsection of section.listItems) {
                ids.push(`${section.id}-${subsection.id}`);
            }
        }
    }
    return ids;
}

export const API_DOCS_SECTIONS = getHrefs();
